import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchCheckInLocationItems() {
	let checkInLocationItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: 'settings/checkinlocation',
		});

		const { data } = response;
		checkInLocationItems = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return checkInLocationItems;
}

export async function createCheckInLocationItems(payload) {
	let createdCheckInLocation;

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: 'settings/checkinlocation',
			data: {
				p_location_name: payload.locationName,
				p_is_active: payload.is_active,
			},
		});

		const { data } = response;
		createdCheckInLocation = data;
	} catch (e) {
		showMessage(e);
	}
	return createdCheckInLocation;
}

export async function updateCheckInLocationItems(payload) {
	let updatedCheckInLocation;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/checkinlocation',
			data: {
				p_location_id: payload.locationID,
				p_location_name: payload.locationName,
				p_is_active: payload.is_active,
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;
		updatedCheckInLocation = data;
	} catch (e) {
		showMessage(e);
	}

	return updatedCheckInLocation;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/checkinlocationsorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_checkin_location_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}
